module.exports = __webpack_public_path__ + "static/img/add_icon.49af486.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/add_icon.jpg
// module id = C4SS
// module chunks = 10